<template>
  <div class="grid item-header__container h-flex-container">
    <div class="grid__col--8 h-flex-item">
      <div class="item-header__title">{{ item.title }}</div>
      <div class="item-header__description" v-html="item.description"></div>
    </div>
    <div class="grid__col--4 h-flex-item">
      <div class="queue-detail item-header__note grid" v-if="item.note">
        <div class="grid__col--1 h-no-padding h-center-align">
          <i class="fas fa-sticky-note"></i>
        </div>
        <div class="grid__col--11 h-no-margin h-no-padding">
          <div class="item-header__note-text" v-html="item.note"></div>
        </div>
      </div>
      <People :item="item"></People>
      <FileAttachment v-for="(file, index) in agendaFiles" :key="index" :file="file"></FileAttachment>
    </div>
  </div>
</template>

<script>
  import lodash from 'lodash';
  import { mapGetters } from 'vuex';
  import FileAttachment from './FileAttachment.vue';
  import People from './People.vue';

  export default {
    name: 'HeaderItem',
    components: {
      FileAttachment,
      People,
    },
    props: ['item', 'index'],
    computed: {
      ...mapGetters('meetingAgendas', ['currentAgenda']),
      contacts() {
        if (this.item.hasOwnProperty('contactIDs')) {
          return lodash.filter(this.currentAgenda.contacts, contact => this.item.contactIDs.includes(contact.id));
        }
        return [];
      },
      users() {
        if (this.item.hasOwnProperty('fuelUserIDs')) {
          return lodash.filter(this.currentAgenda.users, user => this.item.fuelUserIDs.includes(user.id));
        }
        return [];
      },
      agendaFiles() {
        return this.item.hasOwnProperty('agendaFiles') ? this.item.agendaFiles : [];
      },
    },
    methods: {
      launchModal() {
        this.$store.dispatch('meetingAgendas/activateModal', this.index);
      },
    },
  };
</script>

